<!--
 * @Author: 汪俊洪
 * @Date: 2021-07-13 18:54:21
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2021-12-20 18:58:10
 * @Description: 显示图片 轮播
-->
<template>
  <el-image
    @click.stop=""
    :src="srcList[0] || goods_default"
    class="imgcontain"
    :preview-src-list="preview ? srcList : []"
  >
    <div slot="error" class="image-slot">
      <i class="el-icon-picture-outline"></i>
    </div>
  </el-image>
</template>

<script>
import goods_default from '../../assets/img/goods_default.png'
export default {
  props: {
    src: {
      type: String,
      default: ''
    },
    preview: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    srcList () {
      return this.src ? this.src.split(',') : []
    }
  },
  data () {
    return {
      goods_default
    }
  }
}
</script>

<style>
.image-slot {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  font-size: 30px;
  color: #909399;
  background: #e5e5e5;
}
.imgcontain img {
  object-fit: contain;
}
</style>
